var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCheckCircleFill = function SvgCheckCircleFill(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m10.6 13.8-2.2-2.2a1 1 0 0 0-.7-.3 1 1 0 0 0-.7.3 1 1 0 0 0-.2.8c0 .2 0 .5.3.7l2.8 2.8c.2.2.4.3.7.3s.5-.1.7-.3l5.7-5.7.3-.6a1 1 0 0 0-.4-.8 1 1 0 0 0-.6-.2 1 1 0 0 0-.8.3zM12 22a9.7 9.7 0 0 1-7-3A10 10 0 0 1 2.7 8.2 10 10 0 0 1 12 2a9.7 9.7 0 0 1 7 3 10 10 0 0 1 2.2 10.9A10 10 0 0 1 12 22"
  })));
};
export default SvgCheckCircleFill;